import * as React from "react";
import { StyleProp, StyleSheet, ViewStyle } from "react-native";

import { View } from "../../components/Themed";
import { Family } from "../../types";

import FamilyForm, { FamiliesFormProps } from "./FamilyForm";

import commonStyles from "../../styles/common";

export interface FamilyListItemProps extends Pick<FamiliesFormProps, "onSave"> {
  style?: StyleProp<ViewStyle>;
  family: Family;
  disabled?: boolean;
}

function FamilyListItem({
  family,
  style,
  onSave,
  disabled,
}: FamilyListItemProps) {
  return (
    <View style={[style, commonStyles.gridItem]}>
      <FamilyForm
        onSave={onSave}
        family={family}
        style={commonStyles.listItemPrimary}
        disabled={disabled}
      />
    </View>
  );
}

const styles = StyleSheet.create({});

export default FamilyListItem;
